export default __webpack_public_path__ + "static/media/Flag_of_Cayman_Islands.7b8dd96e.svg";